import { SphereIconButton } from "@components/common/sphere-icon-button";
import DateAdapter from "@date-io/luxon";
import { Box, Stack, Typography } from "@mui/material";
import { PickersCalendarHeaderProps } from "@mui/x-date-pickers-pro";
import { DateTime } from "luxon";
import { ChevronLeftIcon, ChevronRightIcon } from "@flat-ui";

/** Content to show above the calendar view, i.e. month with next, previous month buttons */
export function FaroDatePickerHeader({
  currentMonth,
  onMonthChange,
}: PickersCalendarHeaderProps<DateTime>): JSX.Element {
  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        justifyContent: "space-between",
        padding: "8px 16px",
        alignItems: "center",
      }}
    >
      <Stack spacing={1} direction="row">
        <SphereIconButton
          component={ChevronLeftIcon}
          onClick={() =>
            onMonthChange(
              new DateAdapter().addMonths(currentMonth, -1),
              "right"
            )
          }
        />
      </Stack>
      <Typography variant="body2">
        {currentMonth.toFormat("MMMM yyyy")}
      </Typography>
      <Stack spacing={1} direction="row">
        <SphereIconButton
          component={ChevronRightIcon}
          onClick={() =>
            onMonthChange(new DateAdapter().addMonths(currentMonth, 1), "left")
          }
        />
      </Stack>
    </Box>
  );
}
